/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const BodyTableRow = styled.tr`
  background: #fff;
  height: ${({ height }) => `${height}px`};
  border: 1px solid ${Palette.PrimaryGray._200};
  border-top: none;
  border-left: none;
  border-right: none;

  &:nth-child(even) {
    background: #e9eff6;
  }

  &:hover {
    background: ${Palette.PrimaryGray._100};
  }
`;

export const TableData = styled.td`
  padding: 4px;
  color: ${Palette.PrimaryGray._700};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  text-align: center;
`;
